import { PropsWithChildren, useState } from "react";
import { SideNavContext } from "./SideNavContext";

/**
 * SideNavProvider component for managing routing state in SideNav components.
 *
 * Features:
 * - Provides routing context for SideNav components
 * - Manages current location state
 * - Enables client-side routing without page reloads
 * - Integrates with browser history API
 * - Context provider for child components
 *
 * @example
 * <SideNavProvider>
 *   <SideNav>
 *     <SideNav.Link pathname="/intro">Introduction</SideNav.Link>
 *   </SideNav>
 * </SideNavProvider>
 */
export const SideNavProvider = ({ children }: PropsWithChildren) => {
  const [location, setLocation] = useState(window?.location.pathname);

  const sideNavContext = {
    location,
    setLocation,
  };

  return (
    <SideNavContext.Provider value={sideNavContext}>
      {children}
    </SideNavContext.Provider>
  );
};
